/**
 * Distribution Network 그래프 노드(위치) 우클릭 → 관련 화면으로 이동하면서 그 위치를 검색 조건으로
 * 미리 적용하는 액션 정의. FLO 차트의 floNavActions.js 와 동일한 패턴이다.
 * RpDistributionNetwork 의 handleNavigate 가 reduxUtil.updateViewState 로 검색값을 심고
 * updateHistoryState(reduxKey) 로 탭을 연다(App.js 의 historyState 워처가 처리). 대상 화면은
 * 마운트 시 reduxUtil.getViewState(viewName) 으로 그 값을 읽어 초기 조회한다.
 *
 * [주의] updateViewState 는 같은 viewName 의 기존 상태에 "병합"된다. 이전 방문에서 남은 형제
 * 검색 필드가 살아 결과를 과도하게 거를 수 있으므로, 각 payload 는 대상 화면이 읽는 형제 필드를
 * null/빈값으로 함께 비워 깨끗한 단일 조건으로 화면을 연다.
 *
 * [filter.locations 형태 — 확인됨] 위치 검색은 LocationTreeFilter 가 구동하며 redux 의
 * filter.locations 는 "위치 객체 배열"이다. 대상 화면은 location.locCd 로 조회하고(예:
 * RpPolicy.js `searchFilters.locCd = filter.locations.map(l => l.locCd)`), 필터칩 표시에는
 * location.name 을 쓴다. 따라서 최소 형태 { locCd, name } 객체 1개를 배열로 심으면 된다.
 */

// Distribution Network 노드 종류 — 현재는 위치(location) 단일. 향후 엣지/BOD 노드 확장 여지.
export const DIST_KIND = { LOCATION: "location" };

const PAGE_RESET = { currentPage: 1 }; // 항상 1페이지부터
// 위치 검색 필드 형태(필터=locCd, 표시=name). ctx 는 우클릭 컨텍스트 { code: locCd, name }.
const locFilter = (ctx) => [{ locCd: ctx.code, name: ctx.name ?? ctx.code }];

// 위치 노드 액션. payload 는 우클릭 컨텍스트(ctx) 전체를 받는다(코드+이름 모두 필요).
const LOCATION_ACTIONS = [
  {
    id: "rpPolicy", titleKey: "menuRpPolicy", reduxKey: "RP_POLICY",
    // RpPolicy.js 가 읽는 필드: filter{locations,category}, itemSearch, extraItemCodes, selectedSearch, advancedFilters
    payload: (ctx) => ({
      ...PAGE_RESET,
      filter: { locations: locFilter(ctx), category: null },
      itemSearch: "", extraItemCodes: [], selectedSearch: null, advancedFilters: null,
    }),
  },
  {
    id: "rpDemand", titleKey: "menuRpDemand", reduxKey: "RP_DEMAND",
    // RpDemand.js 가 읽는 필드: filter{locations}, itemSearch, customerSearch, extraItemCodes, dpVersion
    payload: (ctx) => ({
      ...PAGE_RESET,
      filter: { locations: locFilter(ctx) },
      itemSearch: "", customerSearch: "", extraItemCodes: [], extraCustomerCodes: [], dpVersion: null,
    }),
  },
];

const ACTIONS_BY_KIND = {
  [DIST_KIND.LOCATION]: LOCATION_ACTIONS,
};

/**
 * 우클릭 컨텍스트(kind/code/name/nodeType)에 해당하는 이동 액션 목록을 반환한다.
 * @param {{kind: string, code: string, name?: string, nodeType?: string}} ctx
 */
export const getNodeNavActions = (ctx) => (ACTIONS_BY_KIND[ctx?.kind] || []).filter((a) => !a.guard || a.guard(ctx));
